export enum ExternalParticipantStatus {
    Accepted = 'Accepted',
    Declined = 'Declined',
    Tentative = 'Tentative',
    Invited = 'Invited',
    None = 'None'
  }
